<template>
    <div class="logo">
        <img alt="语文素养测评" src="@images/logo.png" />
    </div>
</template>

<script lang="ts">
export default {
    name: 'TheLogo'
};
</script>

<style lang="scss" scoped>
.logo {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    img{width: 128px;height: 22px;}
}
</style>
